import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Img from "gatsby-image"
import { graphql, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const AboutPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO title="About" />
      <Layout>
        <section className="row">
          <div className="col-12 col-md-6">
            <Img
              style={{ minWidth: "100%" }}
              fixed={data.ricardo.childImageSharp.fixed}
            />
          </div>
          <div className="col-12 col-md-6">
            <BackgroundImage
              className="d-flex justify-content-center align-items-center"
              style={{ minWidth: `100%` }}
              fixed={data.image1.childImageSharp.fixed}
            >
              <h1 className="text-left text-white display-3">
                About Ricardo Sawir
              </h1>
            </BackgroundImage>
          </div>
        </section>
        <section className="mx-auto my-5" style={{ maxWidth: `650px` }}>
          <p>
            Vivamus ac eros quam. Maecenas malesuada semper lectus eget
            eleifend. Sed magna arcu, pretium at purus at, sagittis auctor
            dolor. Mauris bibendum quis lacus quis facilisis. Aliquam sed eros
            vel mauris mattis suscipit sollicitudin id purus. Etiam eu magna
            quis justo feugiat volutpat. Ut aliquet, orci at hendrerit cursus,
            sem leo interdum odio, consequat dictum urna purus a tortor.
            Phasellus egestas nisi et risus dapibus, quis condimentum justo
            lacinia. Phasellus luctus est in malesuada viverra. Donec tempor
            imperdiet sapien. Maecenas fermentum dictum sapien sit amet varius.
            Quisque tristique facilisis leo. Cras sapien dolor, consequat
            blandit tempor vitae, pulvinar a lectus. Curabitur consectetur,
            ligula at venenatis euismod, enim urna lobortis ex, vitae feugiat
            dui libero et nibh. Nullam fermentum dui vel arcu cursus, in rhoncus
            felis ultricies. Nulla luctus viverra lectus, in consequat augue
            varius vitae.
          </p>
          <p>
            Vivamus ac eros quam. Maecenas malesuada semper lectus eget
            eleifend. Sed magna arcu, pretium at purus at, sagittis auctor
            dolor. Mauris bibendum quis lacus quis facilisis. Aliquam sed eros
            vel mauris mattis suscipit sollicitudin id purus. Etiam eu magna
            quis justo feugiat volutpat. Ut aliquet, orci at hendrerit cursus,
            sem leo interdum odio, consequat dictum urna purus a tortor.
            Phasellus egestas nisi et risus dapibus, quis condimentum justo
            lacinia. Phasellus luctus est in malesuada viverra. Donec tempor
            imperdiet sapien. Maecenas fermentum dictum sapien sit amet varius.
            Quisque tristique facilisis leo. Cras sapien dolor, consequat
            blandit tempor vitae, pulvinar a lectus. Curabitur consectetur,
            ligula at venenatis euismod, enim urna lobortis ex, vitae feugiat
            dui libero et nibh. Nullam fermentum dui vel arcu cursus, in rhoncus
            felis ultricies. Nulla luctus viverra lectus, in consequat augue
            varius vitae.
          </p>
        </section>
        <section>
          <Img
            style={{ maxHeight: `30rem` }}
            fluid={data.background.childImageSharp.fluid}
          />
        </section>
        <section className="mx-auto my-5" style={{ maxWidth: `650px` }}>
          <p>
            Vivamus ac eros quam. Maecenas malesuada semper lectus eget
            eleifend. Sed magna arcu, pretium at purus at, sagittis auctor
            dolor. Mauris bibendum quis lacus quis facilisis. Aliquam sed eros
            vel mauris mattis suscipit sollicitudin id purus. Etiam eu magna
            quis justo feugiat volutpat. Ut aliquet, orci at hendrerit cursus,
            sem leo interdum odio, consequat dictum urna purus a tortor.
            Phasellus egestas nisi et risus dapibus, quis condimentum justo
            lacinia. Phasellus luctus est in malesuada viverra. Donec tempor
            imperdiet sapien. Maecenas fermentum dictum sapien sit amet varius.
            Quisque tristique facilisis leo. Cras sapien dolor, consequat
            blandit tempor vitae, pulvinar a lectus. Curabitur consectetur,
            ligula at venenatis euismod, enim urna lobortis ex, vitae feugiat
            dui libero et nibh. Nullam fermentum dui vel arcu cursus, in rhoncus
            felis ultricies. Nulla luctus viverra lectus, in consequat augue
            varius vitae.
          </p>
          <p>
            Vivamus ac eros quam. Maecenas malesuada semper lectus eget
            eleifend. Sed magna arcu, pretium at purus at, sagittis auctor
            dolor. Mauris bibendum quis lacus quis facilisis. Aliquam sed eros
            vel mauris mattis suscipit sollicitudin id purus. Etiam eu magna
            quis justo feugiat volutpat. Ut aliquet, orci at hendrerit cursus,
            sem leo interdum odio, consequat dictum urna purus a tortor.
            Phasellus egestas nisi et risus dapibus, quis condimentum justo
            lacinia. Phasellus luctus est in malesuada viverra. Donec tempor
            imperdiet sapien. Maecenas fermentum dictum sapien sit amet varius.
            Quisque tristique facilisis leo. Cras sapien dolor, consequat
            blandit tempor vitae, pulvinar a lectus. Curabitur consectetur,
            ligula at venenatis euismod, enim urna lobortis ex, vitae feugiat
            dui libero et nibh. Nullam fermentum dui vel arcu cursus, in rhoncus
            felis ultricies. Nulla luctus viverra lectus, in consequat augue
            varius vitae.
          </p>
        </section>
        <section className="text-center py-5 bg-light">
          <h2 className="text-uppercase">Ready to Chat?</h2>
          <div className="py-3" />
          <Link to="/contact">
            <button
              type="button"
              className="btn text-white"
              style={{ background: "rgb(178, 146, 78)", cursor: "pointer" }}
            >
              Contact Me Today
            </button>
          </Link>
        </section>
      </Layout>
    </React.Fragment>
  )
}

export default AboutPage

export const query = graphql`
  {
    ricardo: file(relativePath: { eq: "aboutPage/ricardosawir.jpg" }) {
      childImageSharp {
        fixed(width: 500, height: 500) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    image1: file(relativePath: { eq: "aboutPage/flower.jpg" }) {
      childImageSharp {
        fixed(width: 500, height: 500) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    background: file(relativePath: { eq: "aboutPage/background.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
